export default function formatMinutesToHours(minutes) {
  return `${Math.round(minutes / 60).toLocaleString()} h`
}
